import { useCallback, useRef, useState } from "react";
const useFocus = ()=>{
    const ref = useRef();
    const [focused, setIsFocused] = useState(false);
    const callbackReference = useCallback((node)=>{
        const handleFocus = ()=>setIsFocused(true);
        const handleBlur = ()=>setIsFocused(false);
        if (ref.current) {
            ref.current.removeEventListener('focus', handleFocus);
            ref.current.removeEventListener('blur', handleBlur);
        }
        ref.current = node;
        if (ref.current) {
            ref.current.addEventListener('focus', handleFocus);
            ref.current.addEventListener('blur', handleBlur);
        }
    }, []);
    return [
        callbackReference,
        focused
    ];
};
export { useFocus };
